
/**
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-09 09:36:09
 * @LastEditTime: 2019-08-09 10:26:56
 * @Version: 1.0
 * @Description: 工具方法
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */

/**
  * 监听文档的事件， 判断是否是传入目标文档的事件。如果不是的时候执行回调
  */
export const DocumentListenter = function(target, eventName, callBack, content) {
  const handle = (e) => {
    let state = false
    if (!e.path) return
    for (const path of e.path) {
      if (target == path) {
        state = true
        break
      }
    }
    if (!state) {
      callBack.apply(content)
    }
  }
  this.cancel = () => {
    document.removeEventListener(eventName, handle)
  }

  if (document) {
    document.addEventListener(eventName, handle)
    return this
  } else {
    throw Error('document object is not exist!')
  }
}

/**
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-09 09:36:09
 * @LastEditTime: 2019-08-09 10:26:56
 * @Version: 1.0
 * @Description: 判断变量是不是数组类型
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */
export const isArray = function(val) {
  return val && (Object.prototype.toString.call(val).indexOf('Array') !== -1)
}

/**
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-09 09:36:09
 * @LastEditTime: 2019-08-09 10:26:56
 * @Version: 1.0
 * @Description: 判断变量是不是空数组
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */
export const isValidArray = function(val) {
  return isArray(val) && val.length > 0
}
